import "./theme.scss";

/**
 * You can import css variables from bootstrap here
 */

const theme = {
  spacing: {
    xs: resolve("--spacer-1"),
    sm: resolve("--spacer-2"),
    md: resolve("--spacer-3"),
    lg: resolve("--spacer-4"),
    xl: resolve("--spacer-5")
  },
  breakpoints: {
    sm: resolve("--breakpoint-sm"),
    md: resolve("--breakpoint-md"),
    lg: resolve("--breakpoint-lg")
  },
  colors: {
    gray: resolve("--gray")
  }
};

export default theme;

function resolve(cssVar: string) {
  return getComputedStyle(document.documentElement).getPropertyValue(cssVar);
}
